<template>
  <div :class="wrapperClasses" v-html="html"></div>
</template>

<script>
export default {
  name: "TextBlock",
  props: {
    section: {
      type: Object
    }
  },
  computed: {
    wrapperClasses() {
      let cls = ["body"];
      if (this.section.type) {
        cls.push(this.section.type);
      }
      return cls;
    },
    html() {
      let html = "";
      if (this.section.markup) {
        html = this.section.markup;
      }
      return html;
    }
  }
};
</script>
